import { DataBean } from "../DataBean";

export class PerformanceObjectiveResult extends DataBean {

  public async getPerformanceObjectiveResultCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "java.util.List_getPerformanceObjectiveResultCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getPerformanceObjectiveResult(idperformanceobjectiveresult: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.PerformanceObjectiveResult_getPerformanceObjectiveResult_Number",
      [idperformanceobjectiveresult]
    );
  }

  public async deletePerformanceObjectiveResult(idperformanceobjectiveresult: number): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "boolean_deletePerformanceObjectiveResult_Number",
      [idperformanceobjectiveresult]
    );
  }

  public async updatePerformanceObjectiveResult(bean: any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.orange.people.talent.bean.PerformanceObjectiveResult_updatePerformanceObjectiveResult_com.orange.people.talent.bean.PerformanceObjectiveResult",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.people.talent.bean.PerformanceObjectiveResult",
        },
      ]
    );
  }
}
